import type { ISVG } from './index';

/**
 * Three stacked registers of different heights — the module's "one asset kind, one shape" idea:
 * a tall image plate, a wide video plate, and an audio envelope. Sidebar nav icon.
 */
export const MediaGallerySVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill='none'
	>
		{/* Image plate — portrait, the shape a campaign poster actually is */}
		<rect
			x='3'
			y='4'
			width='7'
			height='9'
			rx='1'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
		/>
		{/* Video plate — landscape, with the play notch */}
		<rect
			x='13'
			y='4'
			width='8'
			height='6'
			rx='1'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
		/>
		<path
			d='M16.2 5.9v2.2l2-1.1z'
			fill={color || 'currentColor'}
		/>
		{/* Audio envelope — the waveform, which is what makes audio scannable at all */}
		<path
			d='M4 18.5v-2M7 19.6v-4.2M10 18v-1M13 19.9v-4.8M16 18.6v-2.2M19 19.2v-3.4'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
		/>
	</svg>
);
